import PaymentLink from '../services/paymentLink'

export default {
  async getPaymentLink(baseUrl,property,booking,amount) {
    let res

    try {
      res = await PaymentLink.getLink(baseUrl,property,booking,amount)
    } catch (error) {
      res = null
    }

    return res ? res.data : null
  }
}
